module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "registerSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitActivation($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_vm._v("Сваки појединачни ИДФ фактуре мора бити у новом реду")])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "ИДФ фактура"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "6",
      "max-rows": "6"
    },
    model: {
      value: (_vm.invoiceIds),
      callback: function($$v) {
        _vm.invoiceIds = $$v
      },
      expression: "invoiceIds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load || !_vm.invoiceIds
    }
  }, [_vm._v("\r\n            Aктивирај фактуре\r\n            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-80e255a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80e255a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/intervention/activate-invoice/activate-invoice.html
// module id = 797
// module chunks = 1